
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M56.45 25.42a2.19 2.19 0 012.17 2.17c0 .57-.22 1.13-.63 1.54a2.19 2.19 0 01-1.54.63 2.19 2.19 0 01-1.53-.63 2.19 2.19 0 01-.64-1.54c0-.57.24-1.13.64-1.53a2.19 2.19 0 011.53-.64zm-7.16 0a2.18 2.18 0 011.53 3.7 2.19 2.19 0 01-1.53.64 2.19 2.19 0 01-1.54-.63 2.19 2.19 0 01-.63-1.54c0-.57.23-1.13.63-1.53a2.19 2.19 0 011.54-.64zm9.23-7.27a5.65 5.65 0 01-5.65 5.64 5.65 5.65 0 01-5.64-5.64 5.65 5.65 0 015.64-5.65 5.65 5.65 0 015.65 5.65zm-5.65 1.95a1.96 1.96 0 001.96-1.95 1.96 1.96 0 00-1.96-1.96 1.96 1.96 0 00-1.95 1.96c0 1.07.87 1.95 1.95 1.95zM46 4h14a4 4 0 014 4v46a4 4 0 01-4 4H46a4 4 0 01-4-4V8a4 4 0 014-4zm2 4a2 2 0 00-2 2v42a2 2 0 002 2h10a2 2 0 002-2V10a2 2 0 00-2-2H48zM4 40h32a4 4 0 014 4v10a4 4 0 01-4 4H4a4 4 0 01-4-4V44a4 4 0 014-4zm2 4a2 2 0 00-2 2v6a2 2 0 002 2h28a2 2 0 002-2v-6a2 2 0 00-2-2H6z"}})])
          )
        }
      }
    